import { Api } from 'utils';

class ReportService {

	static getVerifications = async (params?: any) => Api.createResponse('client/reports/verifications',params);
	static getCases = async (params?: any) => Api.createResponse('client/reports/verifications/cases',params);
	static getBlackList = async (params?: any) => Api.createResponse('client/reports/black-list',params);
	static getConsultations = async (params?: any) => Api.createResponse('client/reports/consultations',params);
	
	static admin = {
		getVerifications: async (params?: any) => Api.createResponse('admin/reports/verifications',params),
		viewVerification: async (params?: any) => Api.createResponse('admin/reports/verifications/view',params),
		saveStatus: async (params?: any) => Api.createResponse('admin/reports/verifications/save-status',params),
		addBlackList: async (params?: any) => Api.createResponse('admin/reports/verifications/add-black-list',params),
		getBlackList: async (params?: any) => Api.createResponse('admin/reports/black-list',params),
		getClients: async (params?: any) => Api.createResponse('admin/reports/verifications/clients',params),
		getConsultations: async (params?: any) => Api.createResponse('admin/reports/consultations',params),
		viewConsultation: async (params?: any) => Api.createResponse('admin/reports/consultations/view',params),
		saveDocument: async (params?: any) => Api.createResponse('admin/reports/save-document',params),
		loadChats: async (params?: any) => Api.createResponse('admin/reports/load-chats',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/reports/change-status',params),
		sendResponseSocial: async (params?: any) => Api.createResponse('admin/reports/response-social',params),
		sales: {
			get: async (params?: any) => Api.createResponse('admin/reports/sales',params),
			view: async (params?: any) => Api.createResponse('admin/reports/sales/view',params),
			delete: async (params?: any) => Api.createResponse('admin/reports/sales/delete',params),
		},
		appointments: {
			get: async (params?: any) => Api.createResponse('admin/reports/appointments',params),
			view: async (params?: any) => Api.createResponse('admin/reports/appointments/view',params),
			delete: async (params?: any) => Api.createResponse('admin/reports/appointments/delete',params),
		}
	}

}

export default ReportService;